import React from 'react'
import styled from 'styled-components'

const Container = styled.div`
  display: flex;
  gap: 3px;
  font-size: 12px;
`

const Key = styled.span`
  font-weight: 500;
`

export const MetadataItem = ({ itemKey, itemValue }: { itemKey: string, itemValue: string }): JSX.Element => {
  return (
    <Container>
      <Key>{itemKey}:</Key>
      <span>{itemValue}</span>
    </Container>
  )
}
